import { IDocuments, IPaginationResponse } from "../types";
import {
  IBankruptcyEvent,
  IBankruptcyEventParams,
  IBankruptcyEventDocumentsParams,
  IBankruptcyEventsParams,
} from "./types";
import { rootApi } from "../rootApi";

export const bankruptcyEventApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    bankruptcyEvents: builder.query<
      IPaginationResponse<IBankruptcyEvent>,
      IBankruptcyEventsParams
    >({
      query: ({ limit, ordering, offset, tab, issuerId }) => ({
        url: `bankruptcy-events/`,
        params: {
          limit,
          ordering,
          offset,
          tab,
          issuer_id: issuerId || undefined,
        },
      }),
      providesTags: ["bankruptcyEvents"],
    }),
    bankruptcyEvent: builder.query<IBankruptcyEvent, IBankruptcyEventParams>({
      query: ({ id }) => ({
        url: `bankruptcy-events/${id}/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "bankruptcyEvents", id: arg.id },
      ],
    }),
    bankruptcyEventDocuments: builder.query<
      IDocuments[],
      IBankruptcyEventDocumentsParams
    >({
      query: ({ id }) => ({
        url: `bankruptcy-events/${id}/documents/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "bankruptcyEventDocuments", id: arg.id },
      ],
    }),
  }),
});

export const {
  useBankruptcyEventQuery,
  useBankruptcyEventsQuery,
  useBankruptcyEventDocumentsQuery,
} = bankruptcyEventApis;
